(() => {
  const favoriteSelector = '[data-product-favorite][data-product-id]';
  const storagePrefix = 'mocloom:favorite-product:';

  const storageKey = (productId) => `${storagePrefix}${productId}`;

  const readFavorite = (productId) => {
    try {
      return window.localStorage.getItem(storageKey(productId)) === 'true';
    } catch (error) {
      return false;
    }
  };

  const writeFavorite = (productId, isFavorite) => {
    try {
      window.localStorage.setItem(storageKey(productId), isFavorite ? 'true' : 'false');
    } catch (error) {
      // Favor visual feedback even when localStorage is unavailable.
    }
  };

  const setButtonState = (button, isFavorite) => {
    button.classList.toggle('is-active', isFavorite);
    button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
    button.setAttribute('aria-label', isFavorite ? button.dataset.removeLabel : button.dataset.saveLabel);
  };

  const initFavoriteButton = (button) => {
    if (button.dataset.mocloomFavoriteReady === 'true') return;

    button.dataset.mocloomFavoriteReady = 'true';
    button.dataset.saveLabel = button.getAttribute('aria-label') || 'Save product';
    button.dataset.removeLabel = button.dataset.saveLabel.replace(/^Save /, 'Remove ');

    const productId = button.dataset.productId;
    setButtonState(button, readFavorite(productId));

    button.addEventListener('click', () => {
      const nextState = button.getAttribute('aria-pressed') !== 'true';
      writeFavorite(productId, nextState);
      setButtonState(button, nextState);
    });
  };

  const initFavorites = () => {
    document.querySelectorAll(favoriteSelector).forEach(initFavoriteButton);
  };

  const getActiveProductImage = (productForm) => {
    const productInfo = productForm.closest('product-info') || document;
    return (
      productInfo.querySelector('.product__media-item.is-active img') ||
      productInfo.querySelector('.product__media-item[aria-current="true"] img') ||
      productInfo.querySelector('.product__media-wrapper img')
    );
  };

  const runCartFlyout = (productForm) => {
    const image = getActiveProductImage(productForm);
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!image || !cartIcon) return;

    const imageRect = image.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();
    const size = Math.min(96, Math.max(64, Math.min(imageRect.width, imageRect.height) * 0.14));
    const startX = imageRect.left + imageRect.width / 2 - size / 2;
    const startY = imageRect.top + imageRect.height / 2 - size / 2;
    const endX = cartRect.left + cartRect.width / 2 - size / 2;
    const endY = cartRect.top + cartRect.height / 2 - size / 2;
    const flyer = image.cloneNode();

    flyer.removeAttribute('srcset');
    flyer.removeAttribute('sizes');
    flyer.removeAttribute('loading');
    flyer.className = 'mocloom-cart-flyer';
    flyer.style.width = `${size}px`;
    flyer.style.height = `${size}px`;
    flyer.style.setProperty('--fly-start-x', `${startX}px`);
    flyer.style.setProperty('--fly-start-y', `${startY}px`);
    flyer.style.setProperty('--fly-end-x', `${endX}px`);
    flyer.style.setProperty('--fly-end-y', `${endY}px`);

    document.body.appendChild(flyer);
    requestAnimationFrame(() => flyer.classList.add('is-flying'));

    window.setTimeout(() => {
      flyer.remove();
      cartIcon.classList.add('mocloom-cart-pulse');
      window.setTimeout(() => cartIcon.classList.remove('mocloom-cart-pulse'), 560);
    }, 820);
  };

  document.addEventListener('mocloom:cart-add-success', (event) => {
    const productForm = event.target.closest('product-form');
    if (productForm) runCartFlyout(productForm);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFavorites);
  } else {
    initFavorites();
  }

  document.addEventListener('shopify:section:load', initFavorites);
})();
